<script lang="ts">
	import { Button, Container, Icon, Modal, Text, toast } from '@Shelly/shelly-design-system/index';
	import { format } from 'svelte-i18n';
	import { disableEarthDaySceneCreated } from '../PromoCampaigns/earthdayCampaignHelper';
	import { requestDeleteScene } from '../Lists/list-helpers';
	import type { ISceneObj } from 'src/types/SceneType';
	import { ScriptScenesService } from '@Shelly/scenes-script';
	import { resetDrawer, resetDrawerClose } from 'src/helpers/drawer_helpers';
	import { scenes } from 'src/stores/lists/scenes';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	export let showDeleteSceneModal = false;
	export let items: ISceneObj[];
	export let scene_name: string;
	export let scene_id: string;
	export let isScriptScene: boolean;

	const onCloseDeleteModal = () => {
		showDeleteSceneModal = false;
	};

	const onDeleteScene = async () => {
		disableEarthDaySceneCreated(scene_id);

		const res = await requestDeleteScene(scene_id);

		if (items) {
			items = items?.filter((sc) => sc._id !== scene_id);
		}

		if (res.isok) {
			if (isScriptScene) {
				await ScriptScenesService.deleteScriptScene(scene_id);
			}
			scenes.remove(scene_id);
			if ($showNewLayout) {
				resetDrawerClose();
			} else {
				resetDrawer();
			}
		} else {
			return toast.open({
				type: 'danger',
				title:
					$format(`type_del_err_toast`, {
						values: { this_type: $format(`process_delete_scene`) },
					}) || `Failed to delete scene`,
			});
		}
		onCloseDeleteModal();
	};
</script>

<Modal
	on:close={() => onCloseDeleteModal()}
	showModal={showDeleteSceneModal}
	title={$format('prompt_title_delete_scene', { default: 'Delete scene?' })}
>
	<Container slot="content" padding="0">
		<div class="d-flex flex-direction-column align-items-center">
			<Icon size="xxl" icon="fa-light fa-trash" class="text-danger mb-xs" />
			<Text class="text-bold text-center mb-s" styleType="controls-large">
				{scene_name}
			</Text>
			<Text class="width-full">
				{$format('on_delete_item_msg', {
					values: {
						device_name: scene_name,
						type: $format('process_delete_scene', {
							default: 'scene',
						}),
					},
					default: `Deleting {type} ‘{device_name}’ will permanently remove it from your account.`,
				})}
			</Text>
		</div>
	</Container>

	<div slot="footer" class="d-flex justify-content-end">
		<Button
			class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap mr-s"
			responsiveSize={{
				sm: 'm',
			}}
			variant="secondary"
			on:click={() => onCloseDeleteModal()}
		>
			{$format('button_cancel', { default: 'Cancel' })}
		</Button>
		<Button
			class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap"
			variant="danger"
			responsiveSize={{
				sm: 'm',
			}}
			on:click={() => onDeleteScene()}
		>
			{$format('button_delete_scene', { default: 'Delete scene' })}
		</Button>
	</div>
</Modal>
